var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKrl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5B4A84",
    d: "M4.286 12h-.797l.394-1.286h.403V9.257H5.57v2.4l1.715-1.371H8.57v.428l-1.855 1.608l1.855 1.851v.399H7.286l-1.209-1.265l-.506.369v.896H4.286v-.857H3l.394-1.286h.892zm7.83-.428v-1.286h-.639c-.42 0-.956.201-1.191.651v-.651H9v4.286h1.286v-2.25c.004-.802.831-.75 1.83-.75m.947 3.857c1.097-.36 1.684-.99 2.177-1.95c.21-.399.351-.9.549-1.44c-1.338 1.243-1.188 1.243-3.129 2.344zm1.294-3.047l-.643-2.096H12.43c.158.399 1.062 3.12 1.062 3.261c1.432-.497 2.302-1.68 2.323-1.693c.163-.462.313-1.054.472-1.568H15c-.219.814-.373 1.508-.643 2.096m2.357-2.953H18v5.143h-1.286zm1.715-1.286h1.285v6.429H18.43z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKrl);
export default __webpack_public_path__ + "static/media/krl.78a0ce9f9b19f83724e94befb2c440d1.svg";
export { ForwardRef as ReactComponent };